module.exports = __webpack_public_path__ + "img/src/images/fund-saving-plan/industry-4.svg";